import gql from "graphql-tag";
export default {
  getMyAppInPlatform: gql`
    query {
      getMyAppInPlatform {
        id
        name
        url
        iconUrl
        description
        openNewTab
      }
    }
  `,
};
